import { html } from 'lit';
import { i18n } from '@lingui/core';

export const orgRegNumber = (
	registrationNumber?: string,
	dsaAccepted?: boolean,
) => {
	const registrationNumberElement = () =>
		registrationNumber
			? html`
					<p>
						<strong>
							${i18n.t({
								id: 'cvr.no',
								message: 'CVR NO: {cvrNo}',
								values: { cvrNo: registrationNumber },
							})}
						</strong>
					</p>
				`
			: '';

	const dsaAcceptedElement = () =>
		dsaAccepted
			? html`
					<p class="s-text-subtle">
						${i18n.t({
							id: 'dealer.acceptance',
							message:
								'The dealer has accepted that they only advertise in accordance with applicable legislation.',
						})}
					</p>
				`
			: '';

	return html`
		<div class="flex flex-col space-y-6 text-xs">
			${registrationNumberElement()} ${dsaAcceptedElement()}
		</div>
	`;
};
